import { put, takeLatest, call } from "redux-saga/effects";
import { setDrmZipReportDataSuccess, setDrmZipReportDataFailure, setDrmZipReportDataNotExist } from "../reducers/drmCEAZipDownloadSlice";
import { fetchDrmCEAReportZipData } from "../../service/fetchDrmCEAReportZipData";

export function* workerGetDrmZipReportDataFetch({ payload }) {
  try {
    const controller = new AbortController();
    const response = yield call(fetchDrmCEAReportZipData, [controller]);
    if(response.status == 404){
      yield put(setDrmZipReportDataNotExist('No file pending for download'));
    }else {
      const data = response.details.data;

      yield put(setDrmZipReportDataSuccess({data}));
    }
    
  } catch (error) {
    yield put(setDrmZipReportDataFailure(error.toString()));
  }
}

function* drmCEAZipDownloadSaga() {
  yield takeLatest( "zipData/getDrmZipReportData", workerGetDrmZipReportDataFetch );
}

export default drmCEAZipDownloadSaga;
